import {
  updateRec,
  updateWholeRec,
  fetchRecords,
  getWholeRecord,
  addCategory,
  addRecord,
  GetNotificationsForSpecificRecord,
  UpdateNotificationForSpecificRecord,
  get_whole_rec_by_account,
  getNewNotificationProto,
  postNewNotificationProto,
  updateNotification,
  fetchExistingNotifications,
  deleteNotification
} from "../api";
import {
  getMyAcls,
  addRecipientToChannel,
  removeRecipientFromChannel,
  deleteChannel,
  markMessageAsRead
} from "../../api";
import { getDateTime, scoreNode } from "../../utils/api";
import { treePeriodicConverter } from "../../utils/treeUtils";
import { isObjectLike } from "lodash";

export const actions = {
  setAddedValuesSwitch({ commit }, data) {
    commit("Added_VALUES_SWITCH", data);
  },

  updateChartValues({ commit }, data) {
    commit("UPDATE_CHART_VALUES", data);
  },

  setPeriodic({ commit }, data) {
    commit("SET_PERIODIC", data);
  },

  addRecord({ commit }, data) {
    addRecord(data).then(data => {
      //commit('UPDATE_RECORD_LIST', data);
    });
  },

  addCategory({ commit }, data) {
    // Api
    updateRec(data).then(data => {
      commit("FORMAT_CHART", data);
    });
  },

  getRecords({ commit }) {
    fetchRecords().then(recs => {
      commit("LOAD_RECORDS", recs);
    });
  },

  updateChartData({ state, dispatch }, nodeMap) {
    if (!state.nodeMap) {
      return;
    }

    updateWholeRec(nodeMap).then(res => dispatch("updateTabs", res));
  },

  updateChartDataFromTree() {
    // needed for tree vuex operation
  },

  ChartCategoryFilter({ commit }, categoryIdList) {
    commit("CHART_CATEGORY_FILTER", categoryIdList);
  },
  setTemplatesSelected({ commit }, selectedTemplates) {
    commit("SET_SELECTED_TEMPLATES", selectedTemplates);
  },
  setCategoriesSelected({ commit }, selectedCategories) {
    commit("SET_SELECTED_CATEGORIES", selectedCategories);
  },
  createNewTemplate({ commit }, newTemplateData) {
    commit("SET_NEW_TEMPLATE_DATA", newTemplateData);
  },
  ////////////////Record Select//////////////
  async getAccountAndRecord({ commit }, username) {
    // const recordandaccount = await getWholeRecordWithAccount(username);
  },
  async selectAccount({ commit, state, dispatch }, accountUsername) {
    commit("SET_ACCOUNT", accountUsername);
    if (accountUsername) {
      const record = await get_whole_rec_by_account(accountUsername);
      if (record.Error) {
        dispatch("addNotification", {
          type: "warning",
          message: record.Error
        });

        commit("RESET_TABS");
        commit("RESET_ALL_RECORDS");
        return record;
      }

      const datetime = await getDateTime();
      const acls = await getMyAcls(accountUsername);
      // debugger;
      commit("SET_CURRENT_RECORD_TIMESTAMP", datetime.dateTime);
      if (state.selectedRecords?.length) {
        for (let alreadySelectedRecord of state.selectedRecords) {
          if (record._id === alreadySelectedRecord._id) {
            commit("SET_CURRENT_RECORD", record);
            commit("SET_CURRENT_RECORD_INDEX", record);
            return record;
          }
        }
      }
      commit("RESET_TABS");
      commit("ADD_RECORD", record);
      commit("SET_CURRENT_RECORD", record);
      commit("SET_CURRENT_RECORD_INDEX", record);
      commit("SET_RECORDS_OF_SELECTED_ACCOUNT_IS_AUTHORIZED_ON", acls);
      return record;
    } else {
      commit("RESET_TABS");
      commit("RESET_ALL_RECORDS");
    }
  },
  async selectAccountLocallyInMessaging({ commit, state }, accountUsername) {
    const acls = await getMyAcls(accountUsername);
    commit("SET_RECORDS_OF_SELECTED_ACCOUNT_IS_AUTHORIZED_ON", acls);
  },
  async getRecord({ commit, state }, recordId) {
    const record = await getWholeRecord(recordId);
    const datetime = await getDateTime();
    commit("SET_CURRENT_RECORD_TIMESTAMP", datetime.dateTime);
    if (state.selectedRecords?.length) {
      for (let alreadySelectedRecord of state.selectedRecords) {
        if (record._id === alreadySelectedRecord._id) {
          commit("SET_CURRENT_RECORD", record);
          commit("SET_CURRENT_RECORD_INDEX", record);
          return record;
        }
      }
    }
    commit("RESET_TABS");
    commit("ADD_RECORD", record);
    commit("SET_CURRENT_RECORD", record);
    commit("SET_CURRENT_RECORD_INDEX", record);
    return record;
  },
  async updateRecordFromDB({ commit, state }, recordId) {
    await getWholeRecord(state.selectedRecords[0]._id).then(record => {
      for (let alreadySelectedRecord of state.selectedRecords) {
        if (record._id === alreadySelectedRecord._id) {
          commit("SET_CURRENT_RECORD", record);
          commit("SET_CURRENT_RECORD_INDEX", record);
          const params = {
            RecordIndex: state.currentlySelectedRecordIndex,
            Record: record
          };
          commit("UPDATE_CURRENT_RECORD", params);
          commit("RESET_UNEDITED_RECORD");
        }
      }
    });
  },
  updateRecordFromData({ commit, state }, response) {
    for (let alreadySelectedRecord of state.selectedRecords) {
      if (response._id === alreadySelectedRecord._id) {
        commit("SET_CURRENT_RECORD", response);
        commit("SET_CURRENT_RECORD_INDEX", response);
        const params = {
          RecordIndex: state.currentlySelectedRecordIndex,
          Record: response
        };
        commit("UPDATE_CURRENT_RECORD", params);
        commit("RESET_UNEDITED_RECORD");
      }
    }
  },
  SetCurrentRecordAndIndexToNull({ commit }) {
    // commit("SET_CURRENT_RECORD", null);
    commit("SET_CURRENT_RECORD_INDEX", null);
  },
  ResetAllRecords({ commit }) {
    commit("RESET_ALL_RECORDS");
  },
  /////////////////Record Nav ///////////////
  updateTree({ commit }, { RecordIndex, Record, updateDB = false }) {
    commit("UPDATE_CURRENT_RECORD", { RecordIndex, Record });
    if (updateDB) {
      let recordUpdateObject = {
        root_id: Record._id,
        obj: Record
      };
      updateWholeRec(recordUpdateObject);
    }
  },

  ////////////// Record Viewer //////////////
  updateWholeRecord({ state, commit }, tabItemToUpdate) {
    let recordToUpdate;
    for (let record of state.selectedRecords) {
      if (state.currentlySelectedTab.recordId === record._id) {
        recordToUpdate = record;
      }
    }

    const updatedRecord = treePeriodicConverter(
      recordToUpdate,
      state.currentRecordDateTimeStamp
    );

    // Update tab name if this record is open in a tab
    const params = {
      tabItemToUpdate,
      recordToUpdate: updatedRecord
    };
    commit("UPDATE_ACTIVE_TAB_DATA", params);

    let recordUpdateObject = {
      root_id: tabItemToUpdate.recordId,
      obj: updatedRecord
    };

    updateWholeRec(recordUpdateObject);

    //reset unedited record
    commit("RESET_UNEDITED_RECORD");

    // Run through all nodes that have scores and update them
    Object.keys(state.scores).forEach(async node_id => {
      const response = await scoreNode({
        rec_id: tabItemToUpdate.recordId,
        node_id
      });
      if (response?.Success) {
        commit("SET_SCORE_FOR_NODE", {
          node_id: node_id,
          score: response.Success.total
        });
      }
    });
  },
  setupUneditedRecord({ commit, state }, RecordItemTab) {
    for (let record of state.selectedRecords) {
      if (RecordItemTab.recordId == record._id) {
        commit("SET_UNEDITED_RECORD", record);
      }
    }
  },
  resetUneditedRecord({ commit }) {
    commit("RESET_UNEDITED_RECORD");
  },
  discardChangesAndRevertToUneditedRecord({ commit, state }, RecordItemTab) {
    for (let record of state.selectedRecords) {
      if (RecordItemTab.recordId == record._id) {
        commit(
          "REVERT_TO_UNEDITED_STATE",
          state.selectedRecords.indexOf(record)
        );
        commit("RESET_UNEDITED_RECORD");
      }
    }
  },
  getRecordItemOnDemand(
    { state },
    { recorditemid: recordItemId, recordid: recordId }
  ) {
    //wrap in promise
    return new Promise((resolve, reject) => {
      let correctRecordItem;
      function findRecordItemById(RecordItemId, Record) {
        if (Record._id == RecordItemId) {
          correctRecordItem = Record;
        }

        for (let x = 0; x < Record.children.length; x++) {
          findRecordItemById(RecordItemId, Record.children[x]);
        }
      }
      // end of func declaration

      for (let record of state.selectedRecords) {
        //cant find a way to get function to stop when record is found.
        if (recordId == record._id) {
          findRecordItemById(recordItemId, record);
        }
      }

      return resolve(correctRecordItem);
    });
  },
  getRecordNameById: ({ state }, recordId) => {
    for (let record of state.selectedRecords) {
      if (record._id == recordId) {
        return record.name;
      }
    }
  },

  updateRecordParentIdAndChildCount({ state }, record) {
    function updateChildCountAndParentID(recordItem) {
      for (let x = 0; x < recordItem.children.length; x++) {
        recordItem.children[x].parent = recordItem._id;
        updateChildCountAndParentID(recordItem.children[x]);
      }
      recordItem.child_count = recordItem.children.length;
    }
    // end of func declaration

    updateChildCountAndParentID(record);
  },
  addConditionallyHiddenRecordItemId({ commit }, RecordItemId) {
    commit("ADD_HIDDEN_RECORD_ITEM", RecordItemId);
  },
  removeAllConditionalHiddenRecordItemId({ commit }) {
    commit("REMOVE_ALL_HIDDEN_RECORD_ITEMS");
  },
  ///////////// tabs/////////////
  openNewTab(
    { commit, dispatch, state },
    { recordItem, fullRecord, type, datetime, typeSpecificPayload = null }
  ) {
    let idholder = "";
    if (!fullRecord._id) {
      idholder = fullRecord._id;
    }
    // debugger;
    let tab = {
      recordItemId: recordItem._id,
      recordId: fullRecord._id || idholder,
      recordName: fullRecord.name,
      name: recordItem.name,
      type,
      datetime,
      typeSpecificPayload
    };

    // check if tab is already open
    for (const opentab of state.tabs) {
      if (JSON.stringify(opentab) == JSON.stringify(tab)) {
        return dispatch("switchToTab", opentab);
      }
    }

    commit("ADD_TAB", tab);
    commit("SET_CURRENT_TAB", tab);
    commit("UPDATE_ACTIVE_TAB", state.tabs.indexOf(tab));
  },
  switchToTab({ commit, state }, tab) {
    commit("SET_CURRENT_TAB", tab);
    commit("UPDATE_ACTIVE_TAB", state.tabs.indexOf(tab));
  },
  closeTab({ commit, state }, tab) {
    let currentindex = state.tabs.indexOf(tab);
    // check if current tab is the only tab
    if (state.tabs.length == 1) {
      // set to default state
      commit("REMOVE_TAB", currentindex);
      commit("UPDATE_ACTIVE_TAB", 0);
      return commit("RESET_TABS");
    }
    //handle edge case of closing first tab with other tabs open
    else if (currentindex == 0 && state.tabs.length > 1) {
      commit("UPDATE_ACTIVE_TAB", currentindex + 1);
      commit("SET_CURRENT_TAB", state.tabs[currentindex + 1]);
      commit("REMOVE_TAB", currentindex);

      return;
    }
    commit("UPDATE_ACTIVE_TAB", currentindex - 1);
    commit("SET_CURRENT_TAB", state.tabs[currentindex - 1]);
    commit("REMOVE_TAB", currentindex);
  },
  resetAllTabs({ commit }) {
    commit("RESET_TABS");
  },
  /// Events ///
  deleteEvent({ commit, state, dispatch }, { event, recordId }) {
    // Check if this event has a tab open. If so, close it
    const myTab = state.tabs.find(
      tab => tab.type === "event" && tab.typeSpecificPayload === event
    );
    if (myTab) {
      dispatch("closeTab", myTab);
    }
    commit("DELETE_EVENTS_GROUP", {
      event,
      recordId
    });
  },
  renameEvent({ commit, state, dispatch }, { event, newName, recordId }) {
    // Check if this event has a tab open. If so, close it
    const myTab = state.tabs.find(
      tab => tab.type === "event" && tab.typeSpecificPayload === event
    );
    if (myTab) {
      dispatch("closeTab", myTab);
    }
    dispatch("updateRecordFromDB", recordId);
  },

  /// Groups ///
  deleteGroup({ commit, state, dispatch }, { group, recordId }) {
    // Check if this group has a tab open. If so, close it
    const myTab = state.tabs.find(
      tab => tab.type === "group" && tab.typeSpecificPayload === group
    );
    if (myTab) {
      dispatch("closeTab", myTab);
    }
    commit("DELETE_GROUP", {
      group,
      recordId
    });
  },
  ////////////////Graphs/////////////////////////
  FindPeriodicGroupItems({ state }, { recordItemId, recordItem, RecordIndex }) {
    let GroupItems = [];
    function findPeriodicGroup(record, recordItem) {
      if (
        (record.meta.periodic_group &&
          recordItem.meta.periodic_group == record.meta.periodic_group) ||
        record.meta.type === "numeric" ||
        record.meta.type === "numeric-array"
      ) {
        GroupItems.push(record);
      }

      for (let child of record.children) {
        findPeriodicGroup(child, recordItem);
      }
    }
    //end func declaration

    findPeriodicGroup(state.selectedRecords[RecordIndex], recordItem);
    return GroupItems;
  },
  ////////////////Notifications/////////////////////////
  getNotifications({ commit }, recordId) {
    GetNotificationsForSpecificRecord(recordId).then(notifications => {
      commit("SET_USER_NOTIFICATIONS", notifications);
    });
  },
  // updateNotification({ commit }, notification) {
  //   return UpdateNotificationForSpecificRecord(notification);
  // },
  getNotificationProto({ commit }) {
    return getNewNotificationProto();
  },
  fetchExistingNotifications({ commit }, orderid) {
    return fetchExistingNotifications(orderid);
  },
  postNotificationProto({ commit }, notification) {
    return postNewNotificationProto(notification);
  },
  updateNotification({ commit }, notification) {
    return updateNotification(notification);
  },
  deleteNotification({ commit }, orderid, notificationid) {
    return deleteNotification(orderid, notificationid);
  },

  //////messaging////
  addRecipient({ commit }, data) {
    return addRecipientToChannel(data);
  },
  removeChannelRecipient({ commit }, data) {
    return removeRecipientFromChannel(data);
  },
  deleteChannel({ commit }, data) {
    return deleteChannel(data);
  },
  markMessageAsRead({ commit }, data) {
    return markMessageAsRead(data);
  }
};
